window.dremVars.comparePageURL = '/compare/contacts.php';

window.k1Compare = {
	getProduct: function (event) {
		return {
			id: event.target.closest('.k1-compare-js').getAttribute('data-product-id'),
			element: event.target.closest('.k1-compare-js'),
			picture: event.target.closest('.k1-compare-js').getAttribute('data-product-picture'),
			name: event.target.closest('.k1-compare-js').getAttribute('data-product-name')
		};
	},

	getProductFromComparePage: function (event) {
		return {
			id: event.target.closest('.k1-compare-page-js').getAttribute('data-product-id')
		};
	},

	getCookieIds: function (name) {
		return window.k1Cookies.getCookie(name);
	},

	setCookieLife: function () {
		let limitDate = new Date();
		const months = 3;
		limitDate.setMonth(limitDate.getMonth() + months);
		return limitDate
	},

	checkProductInArray: function (product, name) {
		if (!this.getCookieIds(name)) {
			this.addProduct([], product, name)
		}
		if (!JSON.parse(this.getCookieIds(name)).length) {
			this.addProduct([], product, name);
		} else {
			let items = JSON.parse(this.getCookieIds(name));
			if (items.includes(product.id)) {
				this.deleteProduct(items, product, name);
			} else {
				this.addProduct(items, product, name);
			}
		}
	},

	addProduct: function (arr, product, name) {
		arr.push(product.id);
		window.k1Cookies.setCookie(name, JSON.stringify(arr), { path: '/', expires: new Date(this.setCookieLife()) });
		product.element.classList.add('k1-in-compare');
		this.setHeaderCount(arr.length);
		document.querySelector('.k1-header-compare-count-js').classList.add('header__tools-count--show');
		window.k1Action.showAddedModal(window.k1Action.getElements(), product.picture, product.name, arr.length, '/compare/', 'Сравнить', 'сравнение')
	},

	deleteProduct: function (arr, product, name, all = false) {
		if (all) {
			window.k1Cookies.setCookie(name, JSON.stringify([]), { path: '/', expires: new Date(this.setCookieLife()) });
			if (product.element) product.element.classList.remove('k1-in-compare');
			document.querySelector('.k1-header-compare-count-js').classList.remove('header__tools-count--show');
			this.setHeaderCount(arr.length);
			this.setComparePageCount(arr.length);
			return false
		}
		arr.splice(arr.indexOf(product.id), 1);
		window.k1Cookies.setCookie(name, JSON.stringify(arr), { path: '/', expires: new Date(this.setCookieLife()) });
		if (product.element) product.element.classList.remove('k1-in-compare');
		if (!arr.length) {
			document.querySelector('.k1-header-compare-count-js').classList.remove('header__tools-count--show');
		}
		this.setHeaderCount(arr.length);
		this.setComparePageCount(arr.length);
	},

	setHeaderCount: function (count) {
		document.querySelector('.k1-header-compare-count-js').textContent = count;
	},

	setComparePageCount: function (count) {
		if (document.querySelector('.k1-page-compare-count-js')){
			document.querySelectorAll('.k1-page-compare-count-js').forEach(function(item , index) {
				item.textContent = count;
			});
		}
	},

	fillStrokeProperties: function () {
		let propsColumns = document.querySelectorAll('.compare-props-list-js');
		propsColumns.forEach(column => {
			column.querySelectorAll('.compare-props-item.prop-visible-js').forEach((item, idx) => {
				if (idx % 2 === 0) {
					item.classList.add('color-white');
					item.classList.remove('color-grey');
				} else {
					item.classList.remove('color-white');
					item.classList.add('color-grey');
				}
			})
		})
	},

	setHeightLastItem: function () {
		if (!document.querySelector('.compare-field-item-name-js')) return false;
		let descriptions = document.querySelectorAll('.compare-field-item-js');
		let descriptionsName = document.querySelector('.compare-field-item-name-js');
		let height = 0;
		descriptions.forEach(item => {
			if (height < item.clientHeight) {
				height = item.clientHeight
			}
		});

		descriptions.forEach(item => {
			item.style.minHeight = height + 'px';
		});

		descriptionsName.style.minHeight = height + 'px';

	},

	showDifferentProperties: function (event = null) {
		let listWrap;
		let items
		let checkBox;

		if (document.querySelectorAll('.k1-compare-page-js').length <= 1) {
			document.querySelector('.compare-switch-view-js').style.display = 'none';
			return false;
		}

		if (window.innerWidth > 991) {
			listWrap = document.querySelector('.compare').querySelectorAll('.compare__wrap');
			items = document.querySelector('.compare__wrap').querySelectorAll('.compare__item-prop');
		} else {
			listWrap = document.querySelector('.compare-mobile').querySelectorAll('.compare-mobile__row');
			items = document.querySelector('.compare-mobile__row').querySelectorAll('.compare__item-prop');
		}

		if (event) {
			event.preventDefault();
			checkBox = event.target.closest('.compare-switch-view-js');
			checkBox.classList.toggle('k1-show-all');

			if (window.innerWidth > 991) {
				listWrap = event.target.closest('.compare').querySelectorAll('.compare__wrap');
				items = event.target.closest('.compare__wrap').querySelectorAll('.compare__item-prop');
			} else {
				// console.log('event.target: ', event);
				listWrap = event.target.closest('.compare-mobile').querySelectorAll('.compare-mobile__wrap');
				items = event.target.closest('.compare-mobile__row').querySelectorAll('.compare__item-prop');
			}
		}

		if (listWrap) {
			listWrap.forEach(itemWrap => {
				if (event === null) {
					checkBox = itemWrap.querySelector('.compare-switch-view-js');
				}
	
				if (checkBox.classList.contains('k1-show-all')) {
					items.forEach(item => {
						item.classList.add('prop-visible-js')
					})
				} else {
					items.forEach(item => {
						if (!item.classList.contains('prop-different')) {
							item.classList.remove('prop-visible-js')
						}
					})
				}
			})
		}
		
		this.fillStrokeProperties()
	},

	removeItemFromComparePage: function (arr, product, name, event) {
		
		this.deleteProduct(JSON.parse(arr), product, name);

		fetch(window.dremVars.comparePageURL, {
			method: 'post',
			header: {'Conter-type': 'application/json'},
			body: '',
		}).then(response => {
			return response.text();
		}).then(data => {
			let wrapCompare;
			let compareNew;
			let compare;
			const parser = new DOMParser();
			const newDoc = parser.parseFromString(data, 'text/html');

			if (window.innerWidth > 991) {
				wrapCompare = event.target.closest('.compare__wrap');
				compareNew = newDoc.querySelector(`.compare__wrap[data-type="${wrapCompare.getAttribute('data-type')}"]`);
				compare = document.querySelector(`.compare__wrap[data-type="${wrapCompare.getAttribute('data-type')}"]`);
			} else {
				wrapCompare = event.target.closest('.compare-mobile__wrap');
				compareNew = newDoc.querySelector(`.compare-mobile__wrap[data-type="${wrapCompare.getAttribute('data-type')}"]`);
				compare = document.querySelector(`.compare-mobile__wrap[data-type="${wrapCompare.getAttribute('data-type')}"]`);
			}
			
			if (compareNew) {
				compare.innerHTML = compareNew.innerHTML;
			}
			else {
				compare.remove();
			}

			if ( document.querySelector('.k1-page-compare-count-js').textContent == '0')
				window.k1Compare.removeAllItemsFromComparePage('[]',false,'k1CompareGoods', document.querySelector('.remove-all-from-compare-page-js'))

			this.showDifferentProperties();
			this.setHeightLastItem();
			this.fillStrokeProperties();
		}).then(() => {
			window.k1Sliders.makeSlierComparePage(document.querySelector('.compare__slider-container'), document.querySelector('.compare__slider.swiper-container'));
		});

		return false;
	},

	removeAllItemsFromComparePage: function (arr, product, name, button) {
		this.deleteProduct(JSON.parse(arr), product, name, true);
		fetch(window.dremVars.comparePageURL, {
			method: 'post',
			header: {'Conter-type': 'application/json',},
			body: '',
		}).then(response => {
			return response.text();
		}).then(data => {
			const parser = new DOMParser();
			const newDoc = parser.parseFromString(data, 'text/html');

			if (window.innerWidth > 991) {
				compareNew = newDoc.querySelector('.compare');
				compare = document.querySelector('.compare');
			} else {
				compareNew = newDoc.querySelector('.compare-mobile');
				compare = document.querySelector('.compare-mobile');
			}

			compare.innerHTML = compareNew.innerHTML;

			this.showDifferentProperties();
			this.fillStrokeProperties();
		});

		return false;
	},

	init: function () {
		this.fillStrokeProperties();
		this.setHeightLastItem()
	},
};

window.addEventListener('DOMContentLoaded', function () {
	window.k1Compare.init();
});

window.addEventListener('click', e => {
	if (e.target.closest('.k1-compare-js')) {
		window.k1Compare.checkProductInArray(window.k1Compare.getProduct(e), 'k1CompareGoods')
	}

	if (e.target.closest('.compare-switch-view-js')) {
		window.k1Compare.showDifferentProperties(e)
	}

	if (e.target.closest('.remove-from-compare-page-js')) {
		window.k1Compare.removeItemFromComparePage(
			window.k1Compare.getCookieIds('k1CompareGoods'),
			window.k1Compare.getProductFromComparePage(e),
			'k1CompareGoods',
			e
		)
	}

	if (e.target.closest('.remove-all-from-compare-page-js')) {
		window.k1Compare.removeAllItemsFromComparePage(
			'[]',
			false,
			'k1CompareGoods',
			e.target.closest('.remove-all-from-compare-page-js')
		)
	}
	//	remove-from-compare-page-js
});